export default __webpack_public_path__ + "static/media/r-lang.54a08041.svg";